<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<h1 mat-dialog-title>Edit team {{ team?.name }}</h1>
<form class="form" [formGroup]="form" (ngSubmit)="updateTeam()">
  <div class="form-content" mat-dialog-content>
    <mat-form-field appearance="outline">
      <mat-label>Team name</mat-label>
      <input matInput type="text" name="name" formControlName="name" min="3" max="20" />
      @if (form.controls.name?.errors?.required) {
        <mat-error>Team name is required!</mat-error>
      }
      @if (form.controls.name?.errors?.notChanged) {
        <mat-error>Team name must be changed.</mat-error>
      }
    </mat-form-field>
  </div>
  <div class="form-actions" mat-dialog-actions>
    <button
      mat-flat-button
      data-cy="update-btn"
      color="primary"
      aria-label="Update team"
      class="center-content"
    >
      Update team
    </button>
    <button
      mat-button
      data-cy="cancel-btn"
      color="warn"
      aria-label="Cancel updating team"
      mat-dialog-close
    >
      Cancel
    </button>
  </div>
</form>
